<template>
  <div class="home">
    <div class="header">
      <img
        src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/83a833cad3caf31aee667d64a35eceef.jpg~tplv-55ejei7tpt-image.image"
        alt=""
        class="icon-img"
        @click="goHomePage"
      >
    </div>
    <div class="content">
      <p class="title">巨量千川隐私政策</p>
      <p>更新时间：2021年10月26日</p>
      <p class="start-p">北京空间变换科技有限公司及其关联方（简称”我们“）作为巨量千川平台（“巨量千川”）的运营者，深知个人信息对您的重要性，我们将按照法律法规的规定，保护您的个人信息及隐私安全。本隐私政策详细描述了我们如何收集、使用和处理与您有关的个人信息。特别提示：希望您在使用巨量千川及相关服务前仔细阅读并理解本隐私政策，做出适当的选择。使用巨量千川以您接受本政策为前提条件。如对本政策内容有任何疑问、意见或建议，您可通过 customerservice.qianchuan@service.feishu.cn 与我们联系。</p>
      <p>本隐私政策将帮助您了解：</p>
      <p>1. 我们会遵循该隐私政策收集、使用您的信息，但不会仅因您同意本隐私政策而采用强制捆绑的方式一揽子收集个人信息。</p>
      <p>2. 当您使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除了为实现基本业务功能或根据法律法规要求所必需的必要信息，您可以在不影响正常使用巨量千川相关功能的基础上拒绝提供其他信息。我们将在隐私政策中逐项说明哪些是必要信息。</p>
      <p>3. 我们如何收集、使用，存储，传输，共享，转移（如适用）与保护个人信息，如何查询，访问，删除，更正，撤回授权个人信息，其中，有关您个人信息权益的条款重要内容我们已用加粗形式提示，请特别关注。</p>
      <p>摄像头、相册（存储）权限不会默认开启，只有经过您的明示授权才会在为实现特定功能或服务时使用。特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。具体权限申请与使用情况请见：</p>
      <table border="1" cellspacing="0" cellpadding="5">
        <tr>
          <th>信息或权限类型</th>
          <th>使用场景&目的</th>
          <th>使用方式</th>
        </tr>
        <tr>
          <td>相册权限</td>
          <td>用户上传素材</td>
          <td>用户使用广告计划创编环节的素材上传功能</td>
        </tr>
      </table>
      <p>本隐私政策适用于巨量千川数据推广服务平台服务提供者以巨量千川数据推广服务平台网页、PC客户端、供第三方网站和应用程序使用的软件开发工具包（SDK）和应用程序编程接口（API）以及随着技术发展出现的创新形态方式向您提供的产品和服务。如您使用我们向您提供的某项或某几项服务，有其单独的隐私政策的，则相应服务或产品适用相应隐私政策；如未设立独立隐私政策的，则本政策同样适用于该部分产品或服务。</p>
      <p class="title-p">目录：</p>
      <p>一、我们如何收集和使用个人信息</p>
      <p>二、我们对 Cookie 和同类技术的使用</p>
      <p>三、我们如何存储个人信息</p>
      <p>四、数据使用过程中涉及的合作方以及转移、公开个人信息</p>
      <p>五、我们如何保护个人信息的安全</p>
      <p>六、您的权利</p>
      <p>七、未成年人使用条款</p>
      <p>八、隐私政策的修订和通知</p>
      <p>九、联系我们</p>

      <p class="title-p">一、我们如何收集和使用个人信息</p>
      <p>在您使用巨量千川产品及服务的过程中，我们将根据合法、正当、必要的原则，收集信息。我们收集或您提供的信息将用于：</p>
      <p>1.保障产品的正常基础运行</p>
      <p>2.实现各项功能和服务</p>
      <p>3.优化、改善产品和服务</p>
      <p>4.保障产品、服务以及用户使用安全</p>
      <p>5.遵循法律法规与国家标准的规定</p>
      <p>（一）我们直接收集与使用的个人信息</p>
      <p>我们会按照如下方式收集您在使用服务时主动提供的，以及通过自动化手段收集您在使用功能或接受服务过程中产生的信息：</p>
      <p>1.保障巨量千川产品和相关服务的正常运行</p>
      <p>当您使用巨量千川产品及相关服务时，为了保障软件与服务的正常运行，我们会收集您的操作系统版本号、IP 地址、操作日志、浏览器版本、时区等信息。请您了解，这些信息是我们提供服务和保障产品正常运行所必须收集的基本信息。</p>
      <p>2.注册、登录巨量千川产品和相关服务</p>
      <p>（1）您可通过抖店平台（ <a href="https://fxg.jinritemai.com/" target="_blank">https://fxg.jinritemai.com/</a> ）、巨量百应平台（ <a href="www.buyin.jinritemai.com" target="_blank">www.buyin.jinritemai.com</a> )、巨量引擎渠道合作一站式平台（ <a href="https://agent.oceanengine.com/" target="_blank">https://agent.oceanengine.com/</a> ）、或抖音APP小店随心推的开户入口，根据页面提示创建巨量千川账户，或绑定通过前置审核的巨量千川账户。</p>
      <p>（2）为帮助您完成注册或进行登录，我们会收集您的联系邮箱、联系电话或第三方登录账号、密码信息。目前可支持抖音、火山视频、今日头条、西瓜视频的账号进行第三方授权登录。</p>
      <p>（3）在开通巨量千川账户过程中，为帮助您完成实名认证流程，当您以个人作为认证主体时，我们会收集您的个人实名信息（姓名、身份证件），当您以企业作为认证主体时，我们会收集企业的法定代表人个人信息（姓名、身份证件），您可自行上传，或授权抖店平台或巨量百应平台将您的个人认证信息（姓名、身份证件）共享至巨量千川，以优化账户开通流程。</p>
      <p>3.我们在您使用产品或服务过程中收集的信息</p>
      <p>当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
      <p>4.开展营销活动</p>
      <p>当您参加我们举办的营销活动时，根据活动具体规则，我们可能向您收集姓名、通信地址、联系方式、银行帐号等信息。这些信息可能包括个人敏感信息（如个人电话号码、银行帐号等），是您收到转账或者礼品所必要的，如果您拒绝提供这些信息，我们将无法向您转账或发放礼品。</p>
      <p>5.摄像头和相册权限</p>
      <p>为扫描PC端二维码，读取、上传或保存您的创意素材，或在资质认证环节上传文件，您应开启您的摄像头权限和相册权限。</p>
      <p>6.消息通知</p>
      <p>对于您在使用产品及/或服务的过程中提供的您的联系方式（如电子邮箱或联系电话），我们在运营中可能会向其中的一种或多种发送多类通知，用于包括但不限于用户消息告知（包括但不限于充值、下单、退款、赠款、扣款、营销活动、赔付、授权申请或确认等）、身份验证、安全验证、用户使用体验调研和争议处理；此外，我们也可能会向在前述过程中收集的手机号码通过短信、电话的方式，为您提供您可能感兴趣的服务、功能或活动等商业性信息的用途，如您不愿接受这些信息，您可以通过手机短信中提供的退订方式进行退订，或直接与我们联系进行退订。</p>
      <p>7.财务功能</p>
      <p>在您使用巨量千川提供的财务功能时，我们可能会收集您的身份信息和银行账户信息，以便帮助您进行资金管理（包括但不限于充值、退款和开票）。</p>
      <p>（二）我们通过间接获得方式收集到的您的个人信息</p>
      <p>（1）为了给您提供更好、更优、更加个性化的服务，或共同为您提供服务并保障服务的一致性，或为了预防互联网欺诈的目的，我们的关联公司、合作伙伴会依据法律规定或与您的约定或征得您同意前提下，向我们分享您的个人信息。</p>
      <p>（2）为保障服务的一致性，您授权我们获取您抖音帐号的昵称、头像、粉丝数以及其他您授权的帐号信息用于在“巨量千川数据推广服务平台”进行展示。</p>
      <p>（三）保障产品、服务及用户使用安全</p>
      <p>为帮助我们更好地了解巨量千川产品及相关服务的运行情况，以便确保运行与提供服务的安全，我们可能记录网络日志信息，以及使用软件及相关服务的频率、崩溃数据、总体安装、使用情况、性能数据等信息。</p>
      <p>（四）其他用途</p>
      <p>我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善和提升巨量千川产品与服务，为用户营销决策提供产品或技术服务支撑。</p>
      <p>（五）依法豁免征得同意收集和使用的个人信息</p>
      <p>请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：</p>
      <p>（1）与国家安全、国防安全直接相关的；</p>
      <p>（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
      <p>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>（5）所收集的您的个人信息是您自行向社会公众公开的；</p>
      <p>（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
      <p>（7）根据您的要求签订或履行合同所必需的；</p>
      <p>（8）用于维护巨量千川产品及相关服务的安全稳定运行所必需的，例如发现、处置巨量千川产品及相关服务的故障；</p>
      <p>（9）为合法的新闻报道所必需的；</p>
      <p>（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
      <p>（11）法律法规规定的其他情形。</p>
      <p>特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。</p>
      <p class="title-p">二、我们对 Cookie 和同类技术的使用</p>
      <p>Cookie 和同类技术是互联网中的通用常用技术。当您使用“巨量千川数据推广服务平台”及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个 Cookie 或匿名标识符，以收集和存储您访问、使用本产品时的信息。我们使用 Cookie 和同类技术主要为了实现以下功能或服务：</p>
      <p>（一）保障产品与服务的安全、高效运转我们可能会设置认证与保障安全性的 Cookie 或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈等不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。</p>
      <p>（二）帮助您获得更轻松的访问体验使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容、推广计划创建的步骤和流程（例如：记录搜索历史）。</p>
      <p>（三）为您推荐、展示、推送您可能感兴趣的内容或帐号我们可能会利用 Cookie 和同类技术（例如 Beacon、Proxy 等技术）了解您的偏好和使用习惯，进行咨询或数据分析，以改善产品服务及用户体验，并优化您的选择。我们承诺，我们不会将 Cookie 用于本隐私政策所述目的之外的任何其他用途。</p>
      <p class="title-p">三、我们如何存储个人信息</p>
      <p>（一）信息存储的地点</p>
      <p>我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意。</p>
      <p>（二）存储期限</p>
      <p>我们仅在为提供巨量千川产品及服务所必要的期间内保留您的个人信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</p>
      <p class="title-p">四、数据使用过程中涉及的合作方以及转移、公开个人信息</p>
      <p>（一）数据使用过程中涉及的合作方</p>
      <p>1.原则</p>
      <p>1.1 合法原则：与合作方合作过程中涉及数据使用活动的，必须具有合法目的、符合法定的合法性基础。如果合作方使用信息不再符合合法原则，则其不应再使用你的个人信息，或在获得相应合法性基础后再行使用。</p>
      <p>1.2 正当与最小必要原则：数据使用必须具有正当目的，且应以达成目的必要为限。/p>
      <p>1.3 安全审慎原则： 我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。</p>
      <p>2.委托处理</p>
      <p>对于委托处理个人信息的场景，我们会与受托合作方根据法律规定签署相关处理协议，并对其个人信息使用活动进行监督。</p>
      <p>3.共同处理</p>
      <p>对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。</p>
      <p>4.合作方的范围</p>
      <p>若具体功能和场景中涉及由我们的关联方、第三方提供服务，则合作方范围包括我们的关联方与第三方。</p>
      <p>（二）个人信息的转移、公开</p>
      <p>1.我们不会向第三方共享、转让您的个人信息，除非经过您本人事先授权同意，或者共享、转让的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。</p>
      <p>2.个人信息的转移、公开</p>
      <p>2.1 为实现相关功能或服务</p>
      <p>（1）当您在使用巨量千川及其关联方产品或服务，为保障您在我们及关联方提供的产品间所接受服务的一致性，并方便统一管理您的信息，合作方有必要使用您的个人信息。</p>
      <p>（2）如您在巨量千川注册帐号，并在帐号下提交企业或个体工商户的相关资质，则您的抖音帐号在精选联盟平台开通商品分享功能绑定对公提现的银行卡号时，授权巨量千川平台将您的资质信息同步共享至精选联盟平台或抖店平台。</p>
      <p>（3）支付功能：支付功能由与我们合作的第三方支付机构向你提供服务。第三方支付机构为提供功能将使用你的姓名、银行卡类型及卡号、有效期、身份证号码及手机号码。这些信息是支付功能所必需的信息，拒绝上述使用将导致你无法使用该功能，但不影响其他功能的正常使用。</p>
      <p>（4）认证功能：在你使用身份认证的功能或相关服务所需时，根据相关法律法规、安全保障要求可能需要完成实名认证以验证你的身份。在实名认证的过程中，与我们合作的认证服务机构需要使用你的真实姓名、身份证号码、手机号码及面部特征值信息。部分信息是个人敏感信息，拒绝上述使用将导致你无法完成身份认证。这些信息仅供实名认证及法律法规所规定的用途，未经你的明示授权，不会用作其他目的。</p>
      <p>（5）我们可能会与广告合作伙伴共享去标识化或匿名化处理后的信息</p>
      <p>我们可能与委托我们进行推广和广告投放的合作伙伴共享信息，但我们不会分享用于识别您个人身份的信息，例如您的姓名、身份证号等，仅会向这些合作伙伴提供难以识别您个人身份的用户画像标签及去标识化或匿名化后的信息，以帮助其在不识别您个人身份的前提下提升广告有效触达率。</p>
      <p>（6）帮助您参加营销推广活动</p>
      <p>当您选择参加我们举办的有关营销活动时，根据活动需要您提供姓名、通信地址、联系方式、银行帐号等信息。经过您的明示同意，我们会将上述信息与第三方共享以便我们能委托第三方及时向您提供奖品。</p>
      <p>2.2 收购、兼并、重组时个人信息的转移</p>
      <p>随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所要求的安全标准继续保护或要求继受方继续履行个人信息处理者的义务，若继受方变更原先的处理目的、处理方式的，我们将要求继受方重新征得您的授权同意。</p>
      <p>2.3 个人信息的公开披露</p>
      <p>我们不会公开披露您的信息，除非遵循国家法律法规规定或者获得您的同意。我们公开披露您的个人信息会采用符合行业内标准的安全保护措施，如：对违规帐号、欺诈行为进行处罚公告时，我们会披露相关帐号的必要信息。</p>
      <p>请您理解，在下列情形中，根据法律法规及国家标准，我们共享、转让、公开披露您的个人信息无需征得您的授权同意：</p>
      <p>（1）与国家安全、国防安全直接相关的；</p>
      <p>（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的</p>
      <p>（4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>（5）您自行向社会公众公开的个人信息；</p>
      <p>（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
      <p class="title-p">五、我们如何保护个人信息的安全</p>
      <p>（一）我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。</p>
      <p>（二）我们会使用不低于行业同行的加密技术、匿名化处理等合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。</p>
      <p>（三）我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。</p>
      <p>（四）尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码等个人信息透露给他人。</p>
      <p>（五）我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止该等安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以推送通知、邮件、信函、短信等形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。</p>
      <p>（六）我们谨此特别提醒您，本隐私政策提供的个人信息保护措施仅适用于巨量千川产品及相关服务。一旦您离开巨量千川产品及相关服务，浏览或使用其他网站、服务及内容资源，我们即没有能力及义务保护您在巨量千川产品及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于“巨量千川数据推广服务平台”的链接或引导。</p>
      <p class="title-p">六、您的权利</p>
      <p>我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的相关权利。具体路径为：登录巨量千川PC端对应的帐号，在账户信息与设置中进行操作（相关链接为：<a href="https://qianchuan.jinritemai.com/" target="__blank">https://qianchuan.jinritemai.com/）</a>。</p>
      <p>（一） 改变或撤回授权范围</p>
      <p>1. 改变或撤回敏感权限设置</p>
      <p>您可以在设备本身操作系统中关闭相关敏感权限改变同意范围或撤回您的授权。撤回授权后我们将不再收集与这些权限相关信息。</p>
      <p>2. 改变或撤回授权的信息处理</p>
      <p>特定的业务功能和服务需要您的信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供对应的功能和服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响公司此前基于您的授权而开展的个人信息处理。</p>
      <p>（二） 访问和更正您的个人帐号信息</p>
      <p>1. 访问和修改个人帐号信息</p>
      <p>（1）注销帐号</p>
      <p>a.如您希望注销账号，请联系您的对接销售或咨询客服，也可发送邮件至 customerservice.qianchuan@service.feishu.cn ，我们将会在收到您的申请后及时进行处理。在您注销帐号前，我们可能会验证您的个人身份、安全状态、设备信息等，您同意授权并配合我们的账号注销流程。</p>
      <p>b.您知悉并理解，注销帐号的行为是不可逆的行为，当您注销帐号后，我们将删除或匿名化处理您的个人信息，但法律法规另有规定的除外。</p>
      <p>（2）申诉与反馈</p>
      <p>如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索（例如：认为我们收集您的个人信息违反法律规定或者双方约定），您可以通过抖音APP-更多功能-小店随心推-我要反馈，或通过巨量千川官方网站 （<a href="https://qianchuan.jinritemai.com/" target="_blank">https://qianchuan.jinritemai.com/</a>） 右下角-用户反馈入口与我们联系，或者发送邮件至 customerservice.qianchuan@service.feishu.cn，我们将会及时处理回复。</p>
      <p>（3）停止运营向您告知</p>
      <p>如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</p>
      <p>2. 访问隐私政策</p>
      <p>（1）您可以在巨量千川PC端 - 账户 - 账户管理 - 账户信息，或小店随心推 - 账号信息中查看本隐私政策的全部内容。</p>
      <p>（2）请您了解，本隐私政策中所述的巨量千川产品及相关服务可能会因您所使用的手机型号、系统版本、软件应用程序版本、移动客户端等因素而有所不同。最终的产品和服务以您所使用的产品及相关服务为准。</p>
      <p class="title-p">七、未成年人使用条款</p>
      <p>若您是未满18周岁的未成年人，在使用巨量千川产品及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。</p>
      <p>我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、储存、共享、转让或披露未成年人的个人信息；如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。</p>
      <p>若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过公司本隐私政策公示的联系方式与我们联系。</p>
      <p class="title-p">八、隐私政策的修订和通知</p>
      <p>（一）为给您提供更好的服务，巨量千川产品及相关服务将不时更新与变化，我们会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分并具有等同于本隐私政策的效力，未经您明确同意，我们不会削减您依据当前生效的本隐私政策所应享受的权利。</p>
      <p>（二）本隐私政策更新后，我们会在更新后的条款生效前通过官方网站（  <a href="https://qianchuan.jinritemai.com/" target="__blank">https://qianchuan.jinritemai.com/</a> ）公告或其他适当的方式提醒您更新的内容，以便您及时了解本隐私政策的最新版本。</p>
      <p class="title-p">九、联系我们</p>
      <p>如对个人信息保护问题或本隐私政策内容有任何疑问、意见或建议，您可以通过 customerservice.qianchuan@service.feishu.cn 与我们联系。</p>
    </div>
  </div>
</template>

<script>

export default {
  name: "Home",
  methods: {
    goHomePage() {
      window.location.href = window.location.origin;
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  text-align: center;
  .header {
    // position: fixed;
    // top: 0;
    // right: 0;
    // left: 0;
    height: 70px;
    text-align: left;
    padding: 17px 32px;
    z-index: 2;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e5e5;
    border-radius: 1px;
    .icon-img {
      width: 140px;
      height: 35px;
      cursor: pointer;
    }
  }
  .content {
    padding-top: 28px;
    width: 60%;
    margin: 0 auto;
    word-wrap: wrap;
    text-align: justify;
    .title {
      font-weight: 600;
      font-size: 28px;
      line-height: 42px;
      color: #333333;
      margin: 0;
      text-align: center;
    }
    .start-p {
      text-align: justify;
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;
      color: #333333;
      margin-top: 20px;
    }
    .title-p {
      font-size: 14px;
      line-height: 22px;
      // color: #333333;
      text-align: justify;
      font-weight: 600;
      margin-block-start: 20px;
      margin-block-end: 12px;
      // margin-block-end: 8;
    }
    p {
      text-align: justify;
      font-size: 14px;
      margin-block-end: 8px;
      margin-block-start: 8px;
      color: #333;
    }

    table {
      font-size: 14px;
    }
  }
}
</style>
